import Phaser from "phaser";
import { GAME_WIDTH, GAME_HEIGHT, NEXT_CHAR_FONT_SIZE } from "../config";

/** 次の正解文字パネル（画面下中央・大きく表示） */
export class NextCharPanel {
  private charText: Phaser.GameObjects.Text;
  private labelText: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.labelText = scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 90, "NEXT", {
      fontSize: "14px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#aaaaaa",
    });
    this.labelText.setOrigin(0.5, 0.5);
    this.labelText.setDepth(100);

    this.charText = scene.add.text(GAME_WIDTH / 2, GAME_HEIGHT - 50, "", {
      fontSize: `${NEXT_CHAR_FONT_SIZE}px`,
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#00ffcc",
    });
    this.charText.setOrigin(0.5, 0.5);
    this.charText.setDepth(100);
  }

  /** 表示更新 */
  update(nextChar: string): void {
    this.charText.setText(nextChar);
  }
}
